import { useEffect, useState } from "react";
import { services } from "../utils/Data";

export default function ServicesPage() {
  const [loading, setLoading] = useState(false);

  if (loading) {
    return <div className="p-10">Loading services...</div>;
  }

  return (
    <div className="px-4 py-10">
      {/* HEADER */}
      <h1 className="text-3xl font-bold text-green-600 mb-8">Our Services</h1>

      {/* GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services
          .filter((e) => e.subCategory === undefined)
          .map((item) => (
            <a
              key={item.id}
              href={`/services/${item.id}`}
              className="bg-white shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full rounded-lg overflow-hidden"
            >
              {/* IMAGE */}
              <div className="border-2 border-green-500">
                <img
                  src={item.imageSrc}
                  alt={item.course}
                  className="w-full h-52 object-contain"
                />
              </div>

              {/* CONTENT */}
              <div className="flex flex-col flex-1 p-4">
                <h2 className="text-sm font-semibold text-gray-800 min-h-[30px] leading-6">
                  {item.course}
                </h2>

                <p className="text-xs text-gray-500 mt-2 line-clamp-3 min-h-[60px] leading-6">
                  {item.profession}
                </p>

                <div className="mt-auto pt-2">
                  <span className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white text-xs px-4 py-2 rounded-md font-medium transition">
                    Read More →
                  </span>
                </div>
              </div>
            </a>
          ))}
      </div>
    </div>
  );
}
